var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9016 16.3633H6.97266V5.41992H12.9016V16.3633ZM8.32218 14.9671H11.5521V6.85388H8.32218V14.9671Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32209 16.3633H0L3.04094 0.325562H8.32209V16.3633ZM1.64642 14.9671H6.97256V1.75952H4.14755L1.64642 14.9671Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0088 16.3633H11.5518V0.325562H16.9499L20.0088 16.3633ZM12.9013 14.9671H18.3624L15.8073 1.75952H12.9013V14.9671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDam);
export default __webpack_public_path__ + "static/media/dam.ea20f4a9983f8d14cf89466b36aa4a17.svg";
export { ForwardRef as ReactComponent };